<template>
    <v-text-field
        v-focus="filter_menu"
        v-bind="$attrs"
        v-on="$listeners"
        v-model="inputVal"
        hide-details
        :placeholder="$attrs.placeholder ? $t(`lang.${$attrs.placeholder}`) : $t('lang.placeholder_word_phrase')"
        prepend-icon="search"
        single-line
        maxLength="100"
        clearable
        @click:clear="filterClearInput()"
        @keyup.enter="filterTool(params)"
    ></v-text-field>
</template>

<script>
import { mapState } from "vuex";

export default {

    props: ['params', 'value'],
    computed: {
        ...mapState({
            filter_menu: state => state.settings.filter_menu,
        }),
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    }
};
</script>